var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLighthouseIllustration(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 750,
    height: 600,
    viewBox: "0 0 750 600",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M375 593.341C582.107 593.341 750 582.288 750 568.653C750 555.018 582.107 543.964 375 543.964C167.893 543.964 0 555.018 0 568.653C0 582.288 167.893 593.341 375 593.341Z",
    fill: "#E6E9E9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M451 545.249C451 545.249 358.521 582.433 293 546L293.607 535.483L299.253 437.826L304.592 345.427L310.972 235H433.777L439.678 345.427L444.62 437.826L449.839 535.483L451 545.249Z",
    fill: "#0D7D80"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M451 544.82C451 544.82 366.009 582.966 293 545.575L293.607 535H449.839L451 544.82Z",
    fill: "#0A6466"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M445 438H299L304.362 346H440.036L445 438Z",
    fill: "#0A6466"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M373 301C440.379 301 495 246.155 495 178.5C495 110.845 440.379 56 373 56C305.621 56 251 110.845 251 178.5C251 246.155 305.621 301 373 301Z",
    fill: "#0D7D80"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M372.5 346C463.903 346 538 271.903 538 180.5C538 89.0969 463.903 15 372.5 15C281.097 15 207 89.0969 207 180.5C207 271.903 281.097 346 372.5 346Z",
    fill: "#6EB1B3"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M372.5 229C400.39 229 423 206.39 423 178.5C423 150.61 400.39 128 372.5 128C344.61 128 322 150.61 322 178.5C322 206.39 344.61 229 372.5 229Z",
    fill: "#FFA91F"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M441 223H303V238H441V223Z",
    fill: "#3D9799"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M441 173H303V188H441V173Z",
    fill: "#3D9799"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M323 188H315V227H323V188Z",
    fill: "#3D9799"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M345 188H337V227H345V188Z",
    fill: "#3D9799"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M367 188H359V227H367V188Z",
    fill: "#3D9799"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M389 188H380V227H389V188Z",
    fill: "#3D9799"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M410 188H402V227H410V188Z",
    fill: "#3D9799"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M345 128H337V180H345V128Z",
    fill: "#3D9799"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M367 128H359V180H367V128Z",
    fill: "#3D9799"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M389 128H380V180H389V128Z",
    fill: "#3D9799"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M410 128H402V180H410V128Z",
    fill: "#3D9799"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M432 188H424V227H432V188Z",
    fill: "#3D9799"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M324 134H315V180H324V134Z",
    fill: "#3D9799"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M433 134H424V180H433V134Z",
    fill: "#3D9799"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M442 143H303V97.9442L372.5 42L442 97.9442V143Z",
    fill: "#0D7D80"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3019 537.782C38.3543 552.762 52.2346 562.039 52.2346 562.039C52.2346 562.039 59.5447 547.029 55.4923 532.049C51.4399 517.069 37.5596 507.792 37.5596 507.792C37.5596 507.792 30.2495 522.802 34.3019 537.782Z",
    fill: "#6EB1B3"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M40.2591 534.562C51.3788 545.387 52.737 562.027 52.737 562.027C52.737 562.027 36.0665 561.117 24.9467 550.292C13.8269 539.467 12.4688 522.827 12.4688 522.827C12.4688 522.827 29.1393 523.738 40.2591 534.562Z",
    fill: "#9ECBCC"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M211.36 516.212C205.386 538.295 184.923 551.972 184.923 551.972C184.923 551.972 174.146 529.845 180.12 507.761C186.095 485.677 206.557 472 206.557 472C206.557 472 217.334 494.128 211.36 516.212Z",
    fill: "#6EB1B3"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M157.011 516.212C162.985 538.295 183.448 551.972 183.448 551.972C183.448 551.972 194.224 529.845 188.25 507.761C182.276 485.677 161.814 472 161.814 472C161.814 472 151.037 494.128 157.011 516.212Z",
    fill: "#6EB1B3"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M165.789 511.466C182.182 527.423 184.184 551.954 184.184 551.954C184.184 551.954 159.608 550.613 143.216 534.655C126.823 518.697 124.82 494.166 124.82 494.166C124.82 494.166 149.396 495.508 165.789 511.466Z",
    fill: "#9ECBCC"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M202.579 511.466C186.186 527.423 184.184 551.954 184.184 551.954C184.184 551.954 208.76 550.613 225.152 534.655C241.545 518.697 243.548 494.166 243.548 494.166C243.548 494.166 218.972 495.508 202.579 511.466Z",
    fill: "#9ECBCC"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M640.317 279.467C633.926 268.55 621.281 268.041 621.281 268.041C621.281 268.041 608.96 266.448 601.056 283.076C593.689 298.574 583.521 313.537 599.419 317.165L602.291 308.13L604.069 317.838C606.333 318.003 608.603 318.042 610.871 317.956C627.897 317.4 644.111 318.118 643.589 311.942C642.895 303.731 646.466 289.972 640.317 279.467Z",
    fill: "#1D393B"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M622.5 310C631.613 310 639 302.613 639 293.5C639 284.387 631.613 277 622.5 277C613.387 277 606 284.387 606 293.5C606 302.613 613.387 310 622.5 310Z",
    fill: "#CDD3D3"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M616.46 304.486C616.46 304.486 623.841 321.829 614 325.297L623.841 358L640.571 357.009L645 346.108L644.016 329.757L642.54 318.856C642.54 318.856 632.206 321.333 633.19 303L616.46 304.486Z",
    fill: "#CDD3D3"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M611.677 325.06C611.677 325.06 595.533 323.561 597.001 335.552C598.469 347.542 599.936 350.04 599.936 350.04L601.404 368.025L592.598 373.521H584.281C584.281 373.521 558.842 379.516 571.562 386.011C584.281 392.506 588.684 381.015 588.684 381.015C588.684 381.015 612.167 381.015 613.634 377.018C615.102 373.021 611.677 325.06 611.677 325.06Z",
    fill: "#CDD3D3"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M644 320.248C644 320.248 659.258 314.792 660.242 326.695C661.226 338.598 661.226 339.59 661.226 339.59L664.179 356.452C664.179 356.452 670.085 371.331 670.085 375.794C670.085 380.258 674.515 394.145 674.515 394.145C674.515 394.145 680.421 413.487 674.023 412.991C667.625 412.495 666.64 392.161 666.64 392.161L653.351 365.379L649.414 349.013L644 320.248Z",
    fill: "#CDD3D3"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M614.883 323.451H610.945L610.452 344.265C610.452 344.265 604.053 353.186 611.929 361.115L613.898 374L649.835 372.513L652.297 359.133C652.297 359.133 657.219 348.23 650.327 338.319L643.928 318H640.482C640.482 318 648.463 347.625 631.621 348.23C617.837 348.726 614.883 323.451 614.883 323.451Z",
    fill: "#9ECBCC"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M615.784 371L612.802 380.995C612.802 380.995 550.691 556.912 569.573 561.41C588.455 565.908 614.79 571.905 617.274 567.407C619.759 562.909 632.678 431.471 632.678 431.471C632.678 431.471 630.69 568.906 637.15 568.906C643.61 568.906 686.342 569.906 688.827 563.409C691.311 556.912 666.467 382.994 652.057 378.996L648.082 370L615.784 371Z",
    fill: "#1D393B"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M651.488 366L611.805 367.499C611.805 367.499 609.994 380.986 611.805 380.986C612.307 380.986 653.498 384.483 652.995 378.488C652.493 372.494 651.488 366 651.488 366Z",
    fill: "#0A6466"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M623 278C627.971 278 632 273.747 632 268.5C632 263.253 627.971 259 623 259C618.029 259 614 263.253 614 268.5C614 273.747 618.029 278 623 278Z",
    fill: "#1D393B"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M612.909 266C612.91 263.777 613.736 261.633 615.23 259.981C616.724 258.328 618.779 257.285 621 257.051C619.739 256.917 618.464 257.049 617.257 257.438C616.05 257.826 614.94 258.464 613.996 259.308C613.053 260.152 612.299 261.184 611.783 262.337C611.267 263.49 611 264.738 611 266C611 267.262 611.267 268.51 611.783 269.663C612.299 270.816 613.053 271.848 613.996 272.692C614.94 273.536 616.05 274.174 617.257 274.562C618.464 274.951 619.739 275.083 621 274.949C618.779 274.715 616.724 273.672 615.23 272.019C613.736 270.367 612.91 268.223 612.909 266Z",
    fill: "#1D393B"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M637.403 278.742L624.878 272L607.579 274.759L604 291L612.909 290.648L615.398 284.68V290.549L619.509 290.387L621.895 280.887L623.386 291L638 290.693L637.403 278.742Z",
    fill: "#1D393B"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M567.553 334.716L563.012 336.09L583.623 404.202L588.163 402.828L567.553 334.716Z",
    fill: "#0A6466"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M581.16 319.784C582.666 324.748 582.132 330.105 579.675 334.676C577.219 339.248 573.041 342.66 568.061 344.162C563.08 345.664 557.706 345.133 553.118 342.686C548.53 340.238 545.106 336.075 543.598 331.112C540.459 320.775 550.705 287 550.705 287C550.705 287 578.022 309.446 581.16 319.784Z",
    fill: "#0D7D80"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M575.439 325.608C575.937 327.303 576.106 329.083 575.936 330.845C575.767 332.607 575.262 334.318 574.451 335.879C573.64 337.441 572.539 338.822 571.211 339.945C569.882 341.067 568.352 341.909 566.708 342.422C565.063 342.935 563.337 343.109 561.628 342.934C559.918 342.759 558.259 342.239 556.745 341.403C555.23 340.567 553.89 339.432 552.801 338.062C551.712 336.692 550.896 335.115 550.398 333.42C548.306 326.291 555.137 303 555.137 303C555.137 303 573.347 318.479 575.439 325.608Z",
    fill: "#042325"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLighthouseIllustration);
export default __webpack_public_path__ + "static/media/LighthouseIllustration.cf31f9255efb9d4e0cb7fd9481efe3d1.svg";
export { ForwardRef as ReactComponent };